@use '@shared/styles/media' as media;

.footer-container {
  background-color: var(--tg-theme-bottom-bar-bg-color);
}

.footer {
  padding: 0.25rem 0;
  text-align: center;
  font-size: 0.8rem;

  color: var(--tg-theme-hint-color);
}
